import { QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { queryClient } from '@/lib/query-client';
import { AppShell } from '@/components/layout/AppShell';
import DashboardPage from '@/pages/DashboardPage';
import SourcesPage from '@/pages/SourcesPage';
import ParcelsPage from '@/pages/ParcelsPage';
import CrawlsPage from '@/pages/CrawlsPage';
import CoveragePage from '@/pages/CoveragePage';
import CourtDashboardPage from '@/pages/CourtDashboardPage';
import CourtCasesPage from '@/pages/CourtCasesPage';
import CourtSourcesPage from '@/pages/CourtSourcesPage';
import CourtCrawlsPage from '@/pages/CourtCrawlsPage';
import CourtCoveragePage from '@/pages/CourtCoveragePage';

const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'sources', element: <SourcesPage /> },
      { path: 'parcels', element: <ParcelsPage /> },
      { path: 'crawls', element: <CrawlsPage /> },
      { path: 'coverage', element: <CoveragePage /> },
      { path: 'courts', element: <CourtDashboardPage /> },
      { path: 'courts/cases', element: <CourtCasesPage /> },
      { path: 'courts/sources', element: <CourtSourcesPage /> },
      { path: 'courts/crawls', element: <CourtCrawlsPage /> },
      { path: 'courts/coverage', element: <CourtCoveragePage /> },
    ],
  },
]);

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
